module.exports = __webpack_public_path__ + "static/media/one-bed-luxury-bg-1.bd83b4fa.jpg";